export default "__VITE_ASSET__xwIoi6TU__"